(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["g4g-offer-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function initOffers() {
      document.querySelectorAll('[data-g4g-offer]').forEach(function (root) {
        if (root.dataset.ready) return;
        root.dataset.ready = '1';
        var copy = root.querySelector('[data-g4g-copy]');
        if (copy) {
          copy.addEventListener('click', function () {
            var code = copy.getAttribute('data-g4g-copy');
            try {
              navigator.clipboard.writeText(code).then(function () {
                var old = copy.textContent; copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = old; }, 1500);
              });
            } catch (e) {}
          });
        }
        var timer = root.querySelector('[data-g4g-end]');
        if (!timer) return;
        var end = parseInt(timer.getAttribute('data-g4g-end'), 10) * 1000;
        function tick() {
          var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
          if (left <= 0) { root.hidden = true; return; }
          var d = Math.floor(left / 86400), h = Math.floor((left % 86400) / 3600), m = Math.floor((left % 3600) / 60), s = left % 60;
          timer.querySelector('[data-u=d]').textContent = pad(d);
          timer.querySelector('[data-u=h]').textContent = pad(h);
          timer.querySelector('[data-u=m]').textContent = pad(m);
          timer.querySelector('[data-u=s]').textContent = pad(s);
          setTimeout(tick, 1000);
        }
        tick();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initOffers); else initOffers();
    document.addEventListener('shopify:section:load', initOffers);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g4g-popup"]) return;
  try {
    
  (function () {
    var KEY = 'g4g_popup_seen';
    function initPopup() {
      document.querySelectorAll('[data-g4g-popup]').forEach(function (root) {
        if (root.dataset.ready) return;
        root.dataset.ready = '1';
        var design = root.getAttribute('data-design') === 'true';
        var days = parseFloat(root.getAttribute('data-days')) || 3;
        var delay = (parseFloat(root.getAttribute('data-delay')) || 8) * 1000;
        var posted = !!root.querySelector('.g4g-popup__ok') || !!root.querySelector('.g4g-popup__err');
        var lastFocus = null;
        function seen() {
          try { var t = localStorage.getItem(KEY); return !!t && (Date.now() - parseInt(t, 10) < days * 86400000); } catch (e) { return false; }
        }
        function mark() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
        function open() {
          root.hidden = false;
          document.documentElement.classList.add('g4g-popup-open');
          lastFocus = document.activeElement;
          var f = root.querySelector('input[type=email]') || root.querySelector('.g4g-popup__close');
          if (f && f.focus) f.focus();
        }
        function close() {
          root.hidden = true;
          document.documentElement.classList.remove('g4g-popup-open');
          mark();
          if (lastFocus && lastFocus.focus) lastFocus.focus();
        }
        root.querySelectorAll('[data-g4g-close]').forEach(function (b) { b.addEventListener('click', close); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
        if (design || posted) { open(); return; }
        if (seen()) return;
        setTimeout(open, delay);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPopup); else initPopup();
    document.addEventListener('shopify:section:load', initPopup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g4g-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReels() {
      document.querySelectorAll('[data-g4g-reels]').forEach(function (root) {
        if (root.dataset.ready) return;
        root.dataset.ready = '1';
        var vids = root.querySelectorAll('video');
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
              var v = e.target;
              if (e.isIntersecting && e.intersectionRatio > 0.6) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
              else { v.pause(); }
            });
          }, { threshold: [0, 0.6, 1] });
          vids.forEach(function (v) { io.observe(v); });
        }
        root.querySelectorAll('[data-g4g-sound]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var v = btn.parentNode.querySelector('video');
            if (!v) return;
            v.muted = !v.muted;
            btn.innerHTML = v.muted ? '&#128263;' : '&#128266;';
            if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          });
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReels); else initReels();
    document.addEventListener('shopify:section:load', initReels);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
